<template>
  <SACModal
    modalClass="confirm-exit-popup"
    cardClass="exit-card-container"
    :show="show"
    :close="close"
  >
    <template #content>
      <div class="ac-card-content">
        <div class="ac-body-container">
          <img
            src="@shared/assets/img/general/i-red-diamond.svg"
            class="ac-info-logo"
            alt="Information"
          >
          <div class="ac-header">
            Are you sure?
          </div>
          <div class="ac-body">
            Deleted promos cannot be restored.
          </div>
          <div class="flex-row align-center">
            <button
              type="button"
              class="ac-button"
              @click="close"
            >
              Cancel
            </button>
            <button
              type="button"
              class="ac-button"
              @click="deletePromo"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </template>
  </SACModal>
</template>

<script>
import SACModal from '@shared/components/sac/SACModal.vue';

export default {
  name: 'ConfirmDeletePopup',
  components: {
    SACModal,
  },
  props: {
    show: Boolean,
    close: Function,
    deletePromo: Function,
  },
};
</script>
